import { Building2 } from 'lucide-react'
import { formatDate } from '@/frontend/pages/CommandCenter/Organizations/components/organizationFormatting'
import type { OrganizationDetail } from '@/frontend/pages/CommandCenter/Organizations/components/organizationDetailTypes'

interface Props {
  organization: OrganizationDetail
}

export default function OrganizationHeader({ organization }: Props) {
  return (
    <div className="flex flex-col gap-3 md:flex-row md:items-start md:justify-between">
      <div>
        <div className="flex items-center gap-2">
          <Building2 className="h-6 w-6 text-muted-foreground" />
          <h2 className="text-2xl font-bold text-foreground">{organization.name}</h2>
        </div>
        <div className="mt-2 flex flex-wrap items-center gap-2 text-sm text-muted-foreground">
          <span className="font-mono">{organization.slug}</span>
          <span>{organization.owner_email}</span>
          <span>{organization.members_count} membros</span>
          <span>{organization.workers_count} agentes</span>
        </div>
      </div>
      <div className="text-sm text-muted-foreground">Criada em {formatDate(organization.created_at)}</div>
    </div>
  )
}
